<template>
  <div class="tab_head">
    <div class="head">
      <div class="left">
        <img
          class="img"
          src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/logo.png"
        />
      </div>
      <div class="right">
        <img
          class="img"
          v-if="!isShow"
          @click="openShow"
          src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/list.png"
          alt=""
        />
        <img
          class="img"
          @click="openShow"
          v-else
          src="https://rby-shop.oss-cn-hangzhou.aliyuncs.com/official/home/close.png"
          alt=""
        />
      </div>
    </div>
    <div class="show" v-if="isShow">
      <div class="list">
        <div
          class="item"
          @click="changeTabs(index)"
          v-for="(item, index) in tabs"
          :key="index"
        >
          <div class="text" :class="tabIndex == index ? 'text1' : ''">
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="shade" v-if="isShow"></div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  props: {
    tabIndex: Number,
  },
  data() {
    return {
      isShow: false,
      tabs: [
        { name: "首页", path: "/mobile/home" },
        { name: "品牌IP", path: "" },
        { name: "二白Mini", path: "/mobile/product" },
        { name: "用户社区", path: "/mobile/community" },
        { name: "常见问题", path: "/mobile/question" },
        { name: "关于我们", path: "/mobile/about" },
      ],
    }
  },
  methods: {
    openShow() {
      this.isShow = !this.isShow
    },
    changeTabs(e) {
      if (this.tabs[e].path == "") {
        if (this.tabIndex != 0) {
          // let url = this.tabs[0].path + "?state=0"
          this.$router.push( this.tabs[0].path)
          setTimeout(() => {
            this.$emit("child-event", "ip")
          }, 1000)
          this.isShow = false
          return
        } else {
          this.$emit("child-event", "ip")
          this.isShow = false
          return
        }
      }
      if (this.tabIndex != e) {
        this.$router.push(this.tabs[e].path)
      }
      this.isShow = false
    },
  },
}
</script>

<style lang="scss" scoped>
.tab_head {
  width: 100%;
  position: relative;
  .head {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    box-sizing: border-box;
    position: fixed;
    background-color: rgb(2 2 6 / 88%);
    z-index: 100;
    .left {
      .img {
        width: 110px;
        height: 30px;
      }
    }
    .right {
      .img {
        width: 20px;
        height: 20px;
      }
    }
  }
  .show {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    position: fixed;
    background-color: #020206;
    top: 80px;
    left: 0;
    z-index: 100;
    .list {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .item {
        .text {
          color: #808082;
          font-size: 1rem;
          margin-bottom: 20px;
        }
        .text1 {
          color: #fff;
        }
      }
    }
  }
  .shade {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #000000a4;
    z-index: 99;
  }
}
</style>
